import type { ReactElement } from 'react';

interface Props {
  /** Nombre legible del elemento, para el nombre accesible de cada botón. */
  label: string;
  active: boolean;
  busy: boolean;
  onEdit: () => void;
  onToggle: () => void;
}

/** Estado legible del elemento (nunca el booleano crudo, UX-COPY-01). */
export function ActiveBadge({ active }: { active: boolean }): ReactElement {
  return (
    <span className={`badge ${active ? 'b-ok' : 'b-mut'}`}>
      {active ? 'Activo' : 'Desactivado'}
    </span>
  );
}

/** Acciones al final de la fila: editar y desactivar o reactivar. El nombre
 *  accesible nombra el elemento ("Editar Procedimiento"); mientras guarda, la
 *  fila se deshabilita para evitar el doble envío (UX-FB-01). */
export function RowActions({ label, active, busy, onEdit, onToggle }: Props): ReactElement {
  return (
    <div className="row-actions">
      <button
        type="button"
        className="btn sm mut"
        aria-label={`Editar ${label}`}
        disabled={busy}
        onClick={onEdit}
      >
        Editar
      </button>
      <button
        type="button"
        className={`btn sm ${active ? 'danger' : 'mut'}`}
        aria-label={`${active ? 'Desactivar' : 'Reactivar'} ${label}`}
        disabled={busy}
        onClick={onToggle}
      >
        {active ? 'Desactivar' : 'Reactivar'}
      </button>
    </div>
  );
}
